require('./style.less');

var Marionette = require('marionette'),
	_ = require('underscore');

require('chosenBundle');

module.exports = Marionette.ItemView.extend({

	tagName: 'select',
	className: 'graphicStampSelect',
	template: require('./template.hbs'),

	initialize: function(options) {

		this.graphicStamps = options.graphicStamps;
		this.parent = options.parent; //now assuming tied to the notes view, may not want
		this.noteModel = options.noteModel;
		this.initialStamp = options.initialStamp;
		this.numberOptions = 0;

	},

	/**
	 * If there are none, will return empty array ( for both stamp types now types now )
	 * TODO
	 * - if there are none, will need to put in that from the stamp note in the view -- THIS MAY BE A BUG ALONG WITH MODIFY ( eg stamp deleted )
	 */
	serializeData: function() {

		var myStampDataToPopulateDropdown = this.graphicStamps.getDataToPopulateCreateStampDropDown();

		this.numberOptions = myStampDataToPopulateDropdown.length;

		return {
			stamps: myStampDataToPopulateDropdown
		};

	},
	onRender: function() {
		// set the value of the select before applying chosen plugin
		// there wouldn't be an initial stamp if this.numberOptions = 0, so would get an error setting its value
		this.initialStamp && this.$el.val( this.initialStamp.get('id') );

		// disable if there are no more choices to chose from
		if ( this.numberOptions < 2 )
			this.$el.attr('disabled', 'disabled');

	},

	// for the image extension to work, the view must first be in the DOM,
	// unlike chosen without the extension (or not utilizing it )
	onShow: function() {

		this.$el
			.chosen({
				width: '100%',
				placeholder_text_single: 'Select a Stamp...',
				// no option in the image extension to set a class -- it will only take the template
				// here can put in own class name, alternative is to override the predefined styles in node_modules/css ...
				html_template: '<img class="chose-image-stamp" src="{url}" />{text}'
			})
			.on('change', _.bind( this._onStampSelectChange, this) );

		// ugh: known issue -- when searching the images disappear: https://github.com/websemantics/Image-Select/issues/29

	},
	// maybe want less coupled to parent view, now working on noteUIModel, but that's not a part of this view
	_onStampSelectChange: function(e, params) {

		this.parent.triggerMethod( 'userChangedStamp', this.graphicStamps.getStampModelFromId( parseInt( params.selected ) ) );

	},

	onBeforeDestroy: function() {
		this.$el
			.off()
			.chosen('destroy');

	}
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/note/graphicStamp/graphicStampSelector/view.js
 ** module id = 305
 ** module chunks = 0
 **/